import axios from "axios";

const authApiInstance = axios.create({
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
    }
});

authApiInstance.interceptors.request.use((config) => {

    const devEnv = localStorage.getItem("dev-env");
    const envUrl = localStorage.getItem("apiUrl");
    let apiUrl;
    
        if(envUrl === "https://api.optim8.io/") {
            apiUrl = `https://master.ums.bm-services.net/`;
        } else if (envUrl === "https://staging-api.optim8.io/") {
            apiUrl = `https://stage.ums.bm-services.net/`;
        } else {
            apiUrl = `https://stage.ums.bm-services.net/`;
        }

    // config.baseURL = `${apiUrl}api/users`;
    config.baseURL = `${apiUrl}api`;
    return config;
    
}, (error) => {
    return Promise.reject(error);
});

export default authApiInstance;